import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=435cf84f&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=435cf84f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435cf84f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('435cf84f')) {
      api.createRecord('435cf84f', component.options)
    } else {
      api.reload('435cf84f', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=435cf84f&scoped=true&", function () {
      api.rerender('435cf84f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iCve5ibT4ycf/JS/comp/DocBox.vue"
export default component.exports